import { render, staticRenderFns } from "./orderItems.vue?vue&type=template&id=4a998c70&"
import script from "./orderItems.vue?vue&type=script&lang=js&"
export * from "./orderItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports